const devDomain = '/api';
const proDomain = '/api';

function getStorage(key) {
    // if (key == 'token') {
    //     return process.env.VUE_APP_TOKEN;
    // }
    if (key) {
        return localStorage.getItem(key);
    }
}

function setStorage(key, value) {
    if (key && value) {
        localStorage.setItem(key, value);
    }
}

function clearStorage() {
    // let List = localStorage.getItem('chatList');
    // localStorage.clear();
    // localStorage.setItem("chatList", List);
    localStorage.removeItem('token');
    localStorage.removeItem('sender');
    localStorage.removeItem('refreshToken')
    window.sessionStorage.clear();
}

export { 
	getStorage, 
	setStorage, 
	clearStorage, 
	devDomain,
	proDomain
};
